import { Header } from '@/components/layouts/Header'
import { Footer } from '@/components/layouts/Footer'

export function Layout(): void {
  const app = document.getElementById('app')
  if (!app) return

  // Create layout structure
  const header = Header()
  const main = document.createElement('main')
  main.id = 'page-root'
  main.className = 'min-h-screen'
  const footer = Footer()

  // Clear and append layout
  app.innerHTML = ''
  app.appendChild(header)
  app.appendChild(main)
  app.appendChild(footer)
}
